export function pushDataLayerEvent(event) {
  if (window.dataLayer?.find((element) => element['gtm.start'])) {
    window.dataLayer.push(event);
  }
}

export default pushDataLayerEvent;

export function pushBeginCheckout({ checkout, cart }) {
  const payload = checkout?.payload || {};
  const { orderCurrency, orderTotal } = payload;
  const items = (cart?.orderRows || []).map((row) => ({
    item_id: row.articleNumber,
    item_name: row.name,
    currency: orderCurrency,
    quantity: row.quantity,
    item_category: row.category,
    url: row.url,
  }));

  pushDataLayerEvent({
    event: 'begin_checkout',
    ecommerce: {
      currency: orderCurrency,
      value: orderTotal,
      items,
    },
  });
}
